import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type BindEthAddressRequest = {
  /**  style id */
  ethAddress: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};

export type BindEthAddressSimpleRequest = {
  /**  style id */
  ethAddress: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type BindTwitterUserInfoRequest = {
  /**  style id */
  code: Scalars['String']['input'];
  /**  is public */
  status?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanResponse = {
  data?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type ClaimRequest = {
  app: Scalars['String']['input'];
  bizId?: InputMaybe<Scalars['String']['input']>;
  bizType?: InputMaybe<Scalars['String']['input']>;
  /**  style id */
  templateCode: Scalars['String']['input'];
};

export type CommonPageDto = {
  pageNum?: Maybe<Scalars['String']['output']>;
  pageSize?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['String']['output']>;
};

export type FriendTaskPagination = {
  items?: Maybe<Array<Maybe<FriendTaskStatus>>>;
  pagination?: Maybe<CommonPageDto>;
};

export type FriendTaskStatus = {
  address?: Maybe<Scalars['String']['output']>;
  inWhiteList?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type FriendTaskStatusPageList = {
  data?: Maybe<FriendTaskPagination>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type FriendsTaskStatusPageQueryRequest = {
  page: Scalars['String']['input'];
  pageSize: Scalars['String']['input'];
};

export type GetScoreByTemplateIdsRequest = {
  templateCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type InvitingUserQualifiedResponse = {
  data?: Maybe<InvitingUserQualifiedResponseVo>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type InvitingUserQualifiedResponseVo = {
  qualifiedCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['String']['output']>;
};

export type LoginReq = {
  /**  is public */
  ethAddress: Scalars['String']['input'];
  invitedCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**  style id */
  signature?: InputMaybe<Scalars['String']['input']>;
};

export type LoginResult = {
  token?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type LoginResultResponse = {
  data?: Maybe<LoginResult>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type LoginWithTgReq = {
  /**  style id */
  tgId: Scalars['String']['input'];
  /**  is public */
  tgUserInfoStr?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  bindEthAddress?: Maybe<BooleanResponse>;
  bindEthAddressSimple?: Maybe<BooleanResponse>;
  bindTwitterUserInfo?: Maybe<BooleanResponse>;
  claim?: Maybe<BooleanResponse>;
  login?: Maybe<LoginResultResponse>;
  loginWithTg?: Maybe<LoginResultResponse>;
};


export type MutationBindEthAddressArgs = {
  req: BindEthAddressRequest;
};


export type MutationBindEthAddressSimpleArgs = {
  req: BindEthAddressSimpleRequest;
};


export type MutationBindTwitterUserInfoArgs = {
  req: BindTwitterUserInfoRequest;
};


export type MutationClaimArgs = {
  req: ClaimRequest;
};


export type MutationLoginArgs = {
  req: LoginReq;
};


export type MutationLoginWithTgArgs = {
  req: LoginWithTgReq;
};

export type QualifiedFriendsQueryRequest = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  friendTaskStatusList?: Maybe<FriendTaskStatusPageList>;
  getNonce?: Maybe<StringResponse>;
  getQualifiedFriends?: Maybe<InvitingUserQualifiedResponse>;
  getRank?: Maybe<RankResponse>;
  getTotalScoreByTemplateIds?: Maybe<StringResponse>;
  getUserDetail?: Maybe<UserVoResponse>;
  getUserTaskRecords?: Maybe<TaskRecordListResponse>;
  getUserTaskTemplatesUse?: Maybe<TaskTemplateUseListResponse>;
  isUserInWhiteList?: Maybe<BooleanResponse>;
  manualTaskTemplates?: Maybe<TaskTemplateUseListResponse>;
};


export type QueryFriendTaskStatusListArgs = {
  bizReq?: InputMaybe<FriendsTaskStatusPageQueryRequest>;
};


export type QueryGetNonceArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQualifiedFriendsArgs = {
  bizReq?: InputMaybe<QualifiedFriendsQueryRequest>;
};


export type QueryGetTotalScoreByTemplateIdsArgs = {
  bizReq?: InputMaybe<GetScoreByTemplateIdsRequest>;
};


export type QueryGetUserDetailArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserTaskRecordsArgs = {
  bizReq?: InputMaybe<TaskQueryRequest>;
};


export type QueryGetUserTaskTemplatesUseArgs = {
  bizReq?: InputMaybe<TaskQueryRequest>;
};


export type QueryIsUserInWhiteListArgs = {
  userId: Scalars['String']['input'];
};

export type RankResponse = {
  data?: Maybe<Array<Maybe<RankVo>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type RankVo = {
  cnt?: Maybe<Scalars['String']['output']>;
  ethAddress?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoreInfo = {
  bizId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type StringResponse = {
  data?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type TaskRecord = {
  app?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Scalars['String']['output']>;
  innerUser?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  scoreInfo?: Maybe<Array<Maybe<ScoreInfo>>>;
  status?: Maybe<Scalars['String']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
  taskNo?: Maybe<Scalars['String']['output']>;
  taskTemplateId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type TaskRecordListResponse = {
  data?: Maybe<Array<Maybe<TaskRecord>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateContent = {
  dailyTimesLimit?: Maybe<Scalars['Int']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  twitterName?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateContext = {
  logo?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateUse = {
  content?: Maybe<TaskTemplateContent>;
  context?: Maybe<TaskTemplateContext>;
  innerTotalScore?: Maybe<Scalars['String']['output']>;
  taskCount?: Maybe<Scalars['String']['output']>;
  taskFinishCount?: Maybe<Scalars['String']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
  taskTemplateId?: Maybe<Scalars['String']['output']>;
  taskType?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateUseListResponse = {
  data?: Maybe<Array<Maybe<TaskTemplateUse>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type UserScoreInfo = {
  commonScore?: Maybe<Scalars['String']['output']>;
};

export type UserVo = {
  ethAddress?: Maybe<Scalars['String']['output']>;
  /**  user id */
  id?: Maybe<Scalars['String']['output']>;
  /**  user name */
  name?: Maybe<Scalars['String']['output']>;
  scoreInfo?: Maybe<UserScoreInfo>;
  /**  user status */
  status?: Maybe<Scalars['String']['output']>;
  tgId?: Maybe<Scalars['String']['output']>;
  xId?: Maybe<Scalars['String']['output']>;
};

export type UserVoResponse = {
  data?: Maybe<UserVo>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type TaskQueryRequest = {
  appToken?: InputMaybe<Scalars['String']['input']>;
  taskNos?: InputMaybe<Array<Scalars['String']['input']>>;
  templateCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetTotalScoreByTemplateIdsQueryVariables = Exact<{
  bizReq?: InputMaybe<GetScoreByTemplateIdsRequest>;
}>;


export type GetTotalScoreByTemplateIdsQuery = { getTotalScoreByTemplateIds?: { data?: string } };

export type GetUserTaskRecordsQueryVariables = Exact<{
  bizReq?: InputMaybe<TaskQueryRequest>;
}>;


export type GetUserTaskRecordsQuery = { getUserTaskRecords?: { data?: Array<{ createdAt?: string, taskName?: string, scoreInfo?: Array<{ score?: number }> }> } };


export const GetTotalScoreByTemplateIdsDocument = gql`
    query getTotalScoreByTemplateIds($bizReq: GetScoreByTemplateIdsRequest) {
  getTotalScoreByTemplateIds(bizReq: $bizReq) {
    data
  }
}
    `;
export const GetUserTaskRecordsDocument = gql`
    query getUserTaskRecords($bizReq: taskQueryRequest) {
  getUserTaskRecords(bizReq: $bizReq) {
    data {
      createdAt
      taskName
      scoreInfo {
        score
      }
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getTotalScoreByTemplateIds(variables?: GetTotalScoreByTemplateIdsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetTotalScoreByTemplateIdsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTotalScoreByTemplateIdsQuery>({ document: GetTotalScoreByTemplateIdsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getTotalScoreByTemplateIds', 'query', variables);
    },
    getUserTaskRecords(variables?: GetUserTaskRecordsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetUserTaskRecordsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserTaskRecordsQuery>({ document: GetUserTaskRecordsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getUserTaskRecords', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;